"use strict";

var FulfillerIdentityClient = require("./fulfiller_identity_client");
module.exports = FulfillerIdentityClient;